export default __webpack_public_path__ + "888283cbde643f9320a947212552ae08.svg";